module.exports = __webpack_public_path__ + "static/chirpyest-white-6904b091b076a2e0f2458bc6130b6223.svg";